<template>
  <div class="feed-filter-scroll margin-horizontal">
    <span
      v-for="f in filters"
      :key="f.id"
      class="filter-pill"
      :class="{ active: f.id === modelValue }"
      @click="$emit('update:modelValue', f.id)"
    >
      {{ f.label }}
    </span>
  </div>
</template>

<script setup>
defineProps({
  modelValue: { type: String, required: true },
  filters: {
    type: Array,
    required: true,
  },
})

defineEmits(['update:modelValue'])
</script>

<style scoped>
.feed-filter-scroll {
  display: flex;
  gap: 6px;
  overflow-x: auto;
  padding-bottom: 2px;
  margin-bottom: 10px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.feed-filter-scroll::-webkit-scrollbar {
  display: none;
}
.filter-pill {
  flex-shrink: 0;
  padding: 6px 15px;
  border-radius: 16px;
  font-size: 13px;
  font-weight: 500;
  border: 0.5px solid var(--f7-list-item-border-color, rgba(0, 0, 0, 0.12));
  color: var(--f7-on-surface-variant, #8e8e93);
  background: transparent;
  cursor: pointer;
  transition: all 0.2s;
}
.filter-pill.active {
  background: var(--avocash-green, #1A6B42);
  color: #fff;
  border-color: var(--avocash-green, #1A6B42);
}
</style>